import { NewsPost } from '../types'
import { getNewsPostsSync } from './loader'

// Load all news posts from markdown files
const loadedPosts = getNewsPostsSync()

export const newsPosts: NewsPost[] = loadedPosts

export function getAllPosts(): NewsPost[] {
  return newsPosts
}

export function getPostBySlug(slug: string): NewsPost | undefined {
  return newsPosts.find(post => post.slug === slug)
}

export function getAllTags(): string[] {
  const tags = new Set<string>()
  newsPosts.forEach(post => {
    post.tags.forEach(tag => tags.add(tag))
  })
  return Array.from(tags).sort()
}
